module.exports = __webpack_public_path__ + "03_short_gold.2632f45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_short_gold.png
// module id = J30l
// module chunks = 0